<template>
  <div
    ref="bannerRef"
    class="listing-banner-universal-sketch"
  >
    <div class="info">
      <div
        class="info__title"
        v-html="props.banner.title"
      />
      <div
        class="info__description"
        v-html="props.banner.description"
      />
      <ui-button
        class="info__button"
        :color-mode="UiButtonColorMode.NEUTRAL"
        :variant="UiButtonVariant.OUTLINE"
        :text="props.banner?.button?.text"
        @clicked="onClickBtn"
      />
    </div>
    <div class="image">
      <ui-image
        :src="props.banner.image"
        :alt="t('bannerInjection.bannerImage')"
        loading="lazy"
        decoding="async"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { UiImage } from '@experience/core-image-ui';
  import { UiButton, UiButtonColorMode, UiButtonVariant } from '@experience/core-button-ui';

  import type { GetListingBannersItemBannerParamsResponse } from '@/shared/api/experience';
  import { useI18n } from '@experience/i18n';
  import ru from '../i18n/ru.json';
  import { useBannerNavigation } from '../composables/useBannerNavigation';

  interface Props {
    banner: GetListingBannersItemBannerParamsResponse;
  }

  const props = defineProps<Props>();
  const emit = defineEmits<{ onClick: [] }>();

  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  const { handleBannerClick } = useBannerNavigation();

  const onClickBtn = () => {
    emit('onClick');
    handleBannerClick(props.banner?.button);
  };
</script>

<style lang="scss" scoped>
  @use '@experience/design-tokens/typography' as typography;

  .listing-banner-universal-sketch {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 20px 20px 0;
  }

  .info {
    margin-bottom: 24px;
  }

  .info__title {
    margin-bottom: 8px;

    @include typography.base-700-500-extra;
  }

  .info__description {
    margin-bottom: 16px;

    @include typography.base-400-400-regular;
  }

  .image {
    display: flex;
    flex-grow: 1;
    justify-content: center;

    img {
      max-width: 100%;
    }
  }
</style>
